import enDialogs from './en';
import ruDialogs from './ru';

export default {
  en: {
    ...enDialogs,
  },
  ru: {
    ...ruDialogs,
  },
};
